import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { map } from 'rxjs';
import { DropdownServiceService } from 'src/app/services/dropdown-service.service';
import { CustomDropDownListOptions } from '../custom-drop-down-list/customDropDownList.interface';
import { FieldConfig } from '../dynamic-form/dynamicForm.interface';
import { CustomRadioButtonOptions } from './custom-radio-button';
import { slideDownUp } from '../global-app-animations';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';

@Component({
    selector: 'app-custom-radio-button',
    templateUrl: './custom-radio-button.component.html',
    styleUrls: ['./custom-radio-button.component.scss'],
    animations: [slideDownUp],
    standalone: false
})
export class CustomRadioButtonComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() options: CustomRadioButtonOptions | undefined;
  @Input() field: FieldConfig | undefined;
  @Input() group!: FormGroup | undefined;
  @Input() placeholder?: string='';
  @Input() fieldName?: string='';

  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  data:any;

  // @Output() onDropdownChanges: EventEmitter<any> = new EventEmitter<any>();

  parsedOptions: CustomDropDownListOptions | undefined;
  parsedData: Array<any> | undefined;


  constructor(private dds:DropdownServiceService) {}

  ngOnInit() {

  }

  changes(event:any){
    console.warn(event)
    this.change.emit(event);
  }

  created(id:number){
    if(id == this.field?.value){    
      let element = document.getElementById(`${this.field?.value}`);
      element?.setAttribute('checked','true') 

      console.log(element)
    }
  }

  ngOnChanges(changes: { options: SimpleChange, field: SimpleChange }): void {
    if (!this.group) {
      if (changes.options)
        this.parseOptions(changes.options.currentValue);
      if (changes.field && changes.field.currentValue)
        this.parseData(changes.field.currentValue);
    }
  }

  ngAfterViewInit(): void {
    console.log(this.field)
    if(this.field){
      this.options = _.cloneDeep(this.field?.options as CustomRadioButtonOptions);
    }
      
    
    if(this.options?.api){

      this.data = this.dds.GenericDD(`${this.options?.url}`)
  
          .pipe(
            map(data => {
              console.log(data)
              return (<any>data);
            })
          );
    }else{
      this.data = this.options?.data;
    }
      

  }
  
    //this.dropDownListObj!.value = this.group ?? (this.field?.value! as CustomDropDownListOptions)!.value  ? (this.field?.value! as CustomDropDownListOptions)?.value!: this.field?.value!;

    // imposto focus sull'oggetto se serve
    /*if(this.field != undefined && this.field.autoFocus != undefined && this.field.autoFocus != false) {
      var le = document.getElementById(this.field!.name)!.getElementsByTagName("input");
      for(let i = 0; i < le!.length; i++) {
        le[i].focus();
      }
    }*/
  


  private parseOptions(options: CustomDropDownListOptions) {
    this.parsedOptions = _.cloneDeep(options);
  }

  private parseData(data: Array<any>) {
    this.parsedData = _.cloneDeep(data);
  }

  beforeTooltipOpen(e:any) {
    if(this.field != undefined || this.field != null) {
      if(this.field.tooltip == null || this.field.tooltip == undefined || this.field.tooltip == '') {
        e.cancel = true;
      }
    }
  }
}
